var _defs, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPattern(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: "1440px",
    width: "2560px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "doodad",
    width: 34.64,
    height: 40,
    viewBox: "0 0 69.2820323027551 80",
    patternUnits: "userSpaceOnUse",
    patternTransform: "rotate(135)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "rgba(17, 122, 202,1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.83 50.5L51.96 51L51.09 50.5L51.09 49.5L51.96 49L52.83 49.5z",
    strokeLinejoin: "miter",
    fill: "rgba(33, 30, 30,1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.51 60.5L34.64 61L33.77 60.5L33.77 59.5L34.64 59L35.51 59.5z",
    strokeLinejoin: "miter",
    fill: "rgba(33, 30, 30,1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.19 50.5L17.32 51L16.45 50.5L16.45 49.5L17.32 49L18.19 49.5z",
    strokeLinejoin: "miter",
    fill: "rgba(33, 30, 30,1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.19 30.5L17.32 31L16.45 30.5L16.45 29.5L17.32 29L18.19 29.5z",
    strokeLinejoin: "miter",
    fill: "rgba(33, 30, 30,1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.51 20.5L34.64 21L33.77 20.5L33.77 19.5L34.64 19L35.51 19.5z",
    strokeLinejoin: "miter",
    fill: "rgba(33, 30, 30,1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.83 30.5L51.96 31L51.09 30.5L51.09 29.5L51.96 29L52.83 29.5z",
    strokeLinejoin: "miter",
    fill: "rgba(33, 30, 30,1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.37 41L34.64 42L32.91 41L32.91 39L34.64 38L36.37 39z",
    strokeLinejoin: "miter",
    fill: "rgba(247, 250, 252,1)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#doodad)",
    height: "200%",
    width: "200%"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern);
export default __webpack_public_path__ + "static/media/pattern.ad4b867e251781602df45e3005bed0c4.svg";
export { ForwardRef as ReactComponent };